import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useTestMode } from '../../contexts/TestModeContext';
import { useNavigate } from 'react-router-dom';

const TestModeBanner = () => {
	const { testMode, disableTestMode } = useTestMode();
	const navigate = useNavigate();

	if (!testMode) return null;

	return (
		<Alert variant='warning' className='mb-0 rounded-0 text-center py-2 border-0' style={{ borderBottom: '2px solid #ffc107' }}>
			<div className='d-flex justify-content-center align-items-center gap-3'>
				<div>
					<i className='fa-sharp fa-solid fa-flask me-2'></i>
					<strong>TEST MODE ACTIVE</strong> - Only test students are visible and editable. Real students are protected.
				</div>
				<div className='d-flex gap-2'>
					<Button
						variant='outline-warning'
						size='sm'
						onClick={() => navigate('/portal/work/setup-student-types')}
					>
						<i className='fa-sharp fa-solid fa-users-gear me-1'></i>
						Manage Test Students
					</Button>
					<Button
						variant='warning'
						size='sm'
						onClick={disableTestMode}
					>
						<i className='fa-sharp fa-solid fa-power-off me-1'></i>
						Exit Test Mode
					</Button>
				</div>
			</div>
		</Alert>
	);
};

export default TestModeBanner;
